import React, { useState } from 'react';
import { Paper, Box } from '@material-ui/core';

import { PageContainer } from '@recurrent/shared/build/components';
import {
  useConfig,
  useFetchEffect,
  useSetPageTitle,
} from '@recurrent/shared/build/hooks';

import { fetchAccount as apiFetchAccount } from '../../api';

import LoginForm from '../LoginForm';
import SubscribeForm from '../SubscribeForm';

const PaymentProvider = () => {
  const { brandName } = useConfig();

  useSetPageTitle(brandName);

  const [isReadyForActivation, setReadyActivationStatus] = useState(false);

  const { data: account, fetchData: fetchAccount } = useFetchEffect({
    apiFetchFunction: () => apiFetchAccount({ includeStripeAccount: true }),
    conditionFunction: () => false,
  });

  const onLoginSuccess = () => {
    setReadyActivationStatus(true);
    fetchAccount();
  };

  return (
    <PageContainer>
      <Paper elevation={24}>
        <Box p={4}>
          {isReadyForActivation ? (
            <SubscribeForm customer={account?.stripeAccount} />
          ) : (
            <LoginForm onSuccess={onLoginSuccess} />
          )}
        </Box>
      </Paper>
    </PageContainer>
  );
};

export default PaymentProvider;
